import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BaseComponentDirective, DomUtils, MenuService, WpMenuDataItem } from '@streamamg/amg-common';
import { WpCommonData } from '../../types/wordpress/common-data.type';
import { CloudPayService, CloudPayState } from '@streamamg/cloud-pay-lib';
import { FormControl, FormGroup } from '@angular/forms';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent extends BaseComponentDirective implements OnInit, OnDestroy {

  @Input() wpCommonData: WpCommonData;
  @ViewChild('searchInput') searchInputRef;
  public menu: WpMenuDataItem[];
  public menuOpened: boolean;
  public searchOpened: boolean;
  public userState: CloudPayState;
  public formSearch: FormGroup = new FormGroup({
    q: new FormControl(''),
  });

  public submenusOpened: { [x: string]: boolean };

  constructor(
    private cloudPayService: CloudPayService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private menuService: MenuService,
  ) {

    super();
    this.menuOpened = false;
    this.submenusOpened = {};
  }


  ngOnInit(): void {


    window.addEventListener('click', this.onClickSubMenu);

    super.subSink = this.menuService.getMenuDataItems('header')
      .subscribe((menu) => {
        if (menu) {
          this.menu = menu.items;
          this.cd.markForCheck();
        }
      });


    super.subSink = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {

        this.closeMenu();
      });


    super.subSink = this.cloudPayService.cloudPayState()
      .subscribe((state: CloudPayState) => {

        this.userState = state;
        this.cd.markForCheck();
      });

  }

  public toggleMenu(): void {
    this.menuOpened = !this.menuOpened;
    DomUtils.toggleOverlayClass(!this.menuOpened);
    this.cd.detectChanges();
  }

  public closeMenu(): void {

    this.submenusOpened = {};

    if (this.menuOpened) {
      this.searchOpened = false;

      this.toggleMenu();
    }
  }


  public searchToggle(): void {

    // if (!this.menuOpened) {
    //   DomUtils.toggleOverlayClass(!this.searchOpened);
    // }

    this.searchOpened = !this.searchOpened;

    if (this.searchOpened) {
      // after css transition is terminated
      setTimeout(() => {
        this.searchInputRef.nativeElement.focus();
      }, 700);
    }

    this.cd.detectChanges();
  }

  public submitSearch(event: Event): void {
    event.preventDefault();
    const filters = {...this.formSearch.value};
    Object.keys(filters).forEach((key) => (!filters[key] || filters[key] === '') && delete filters[key]);

    this.router.navigate([`/${this.wpCommonData.pages.archive}`], {queryParams: filters});
    this.searchToggle();
    this.formSearch.reset();
    this.searchInputRef.nativeElement.blur();
  }

  public searchClean(): void {
    this.formSearch.reset();
    this.cd.detectChanges();
  }

  public toggleSubmenu(index: number): void {

    this.submenusOpened[`i-${index}`] = !this.submenusOpened[`i-${index}`];
    this.cd.detectChanges();
  }

  onClickSubMenu = (e) => {
    document.querySelectorAll('header .header__menu-content .item').forEach((element, index) => {

      if (element?.classList.contains('submenu') && !element?.contains(e.target)) {

        this.submenusOpened[`i-${index}`] = false;
        this.cd.detectChanges();
      }
    });
  };


  ngOnDestroy(): void {
    window.removeEventListener('click', this.onClickSubMenu, false);
    super.ngOnDestroy();
  }

}
